import useLoadingTimer from 'common/hooks/utils/useLoadingTimer';
import { useMemo } from 'react';

const useLoadingTimerAlert = isLoading => {
  const loadingTimer = useLoadingTimer(isLoading);

  const alert = useMemo(() => {
    if (loadingTimer === 0) return null;

    if (loadingTimer > 20)
      return {
        title: 'Almost finished!',
        description: 'Your information is being finalized'
      };

    if (loadingTimer > 7)
      return {
        title: 'Collecting everything you need...',
        description: 'Please wait a moment!'
      };
  }, [loadingTimer]);

  return alert;
};

export default useLoadingTimerAlert;
